import { getPageViewInfinityTagParameters, getOnLoadInfinityTagParameters, getOracleCookieId } from './infinity-tag-parameters';

( function(){

	// Declare Your Parameters (or leave object empty {})
	const infinityParams = getPageViewInfinityTagParameters();
	var cxDataObject = Object.assign( {}, window.oracleInfinityTag ? window.oracleInfinityTag.inifinityParams : {}, infinityParams );
	// Global object from Oracle Infinity //
	window.ORA = window.ORA || {productReady: []};
	infinityPageViewCall( cxDataObject );
	let oracleResponse;
	fetchUnityData().then( function ( response ) {
		oracleResponse = response;
	} ).catch( function( error ) {
		oracleResponse = error;
		console.error( error );
	} ).finally( function() {
		/* Start - Store Oracle response in ISM data Stack */
		let ism = window.adstackData && window.adstackData.ism;
		ism && ism.enabled && typeof ism.dataStack !== 'undefined' && Array.isArray( ism.dataStack ) && ism.dataStack.push( { 'identityServiceProvider' : 'Oracle', value : oracleResponse } ) ;
		/* End - Store Oracle response in ISM data Stack */
		/* send how long oracle infinity took to respond to new relic */
		const oracleEnd = performance.now();
		const requestData = window.hmUtils && window.hmUtils.getNavigationAPIPerfEntries();
		const responseEnd = requestData && requestData.responseEnd;
		let newRelicData = {};
		newRelicData['eventType'] = 'Provider Response Time Metric for ISM';
		newRelicData['ProviderName'] = 'Oracle';
		newRelicData['pageUrl'] = location.href;
		newRelicData['browser'] = window.hmUtils && window.hmUtils.getBrowserName();
		newRelicData['sessionID'] = window.hmUtils && window.hmUtils.getOracleCookieId();
		newRelicData['OracleResponse'] = JSON.stringify( oracleResponse );
		newRelicData['Response time(seconds)'] = ( oracleEnd - responseEnd ) / 1000 ;
		window.hmLog && window.hmLog.sendToNewRelic( newRelicData, true );
	} );

	/**
	 * On load event, we fire the click view call with all the user data that is available from other sources like AIM, Lytics etc.
	 */
	window.addEventListener( 'load', function() {
		infinityClickViewCall( getOnLoadInfinityTagParameters() );
		sendDataToDataLayer();
	} );

	/**
	 * Page view call to Infinity which is fired on Page view. This has to be called only once.
	 * @param cxDataObject
	 */
	function infinityPageViewCall( cxDataObject ) {
		// DO NOT EDIT BELOW THIS LINE - ORA.view()
		window.ORA.productReady.push( ['analytics', function( cxDataObject ) {
			return function() {
				return window.ORA.view( {'data': cxDataObject} );
			};
		}( cxDataObject )] );
	}

	/**
	 * Click View call to Infinity which acts like a custom event to send data available from all async services.
	 */
	function infinityClickViewCall( cxDataObject ) {
		// DO NOT EDIT BELOW THIS LINE - ORA.click()
		window.ORA.productReady.push( ['analytics', function( cxDataObject ){
			return function() {
				return window.ORA.click( {'data':cxDataObject} );
			};
		}( cxDataObject )] );
	}

	/**
	 * Fetch API promise to fetch unity data based on the query params.
	 * @return {Promise<any>}
	 */
	async function fetchUnityData() {
		try {
			let unityAPIUrl =  window.oracleInfinityTag ? window.oracleInfinityTag.unity_api_url : '';
			const loggedInUserData = window.hmUtils.getUserData();
			const subscriberData = loggedInUserData && loggedInUserData.subscriber;
			let lookupParams = { // add more lookups(query params) to this object
				'npiNumber' : window.Cookies && window.Cookies.get( 'hmNpiId' ),
				'hashedEmail' : subscriberData && window.hmUtils.getHashedEmail(),
				'oracleCookieId' : getOracleCookieId(),
				'hashedSubscriberId' : subscriberData ? subscriberData.subscriberHashId : ''
			} ;
			let lookupParamsString = ''; // serialize query params string
			let lookupParamsKeyCount = Object.keys( lookupParams ).length ;
			for ( let key in lookupParams ) {
				if( lookupParams[key] ) { // check if key is empty
					if( Object.keys( lookupParams ).length > lookupParamsKeyCount ) {
						lookupParamsString += '&';
					}
					lookupParamsString += `${key}=${encodeURIComponent( lookupParams[key] )}`;
					lookupParamsKeyCount--;
				}
			}
			if( lookupParamsString ) {
				unityAPIUrl = `${unityAPIUrl}?${lookupParamsString}`;
			}
			let response = await fetch( unityAPIUrl );
			if ( response.ok ) { //to send data only when it is successful. Fetch API resolves also in the case of 4xx and 5xx errors.
				let results = await response.json();
				return results;
			}
			return Promise.reject( `Promise resolved but HTTP status failed - ${response.status}` );
		} catch ( e ) {
			return Promise.reject( 'Something went wrong with the code!' );
		}
	}

	/** data that needs to go to DataLayer should be added to data variable.
	 * At this point, it is only oracleCookieID.
	 */
	function sendDataToDataLayer() {
		window.dataLayer = window.dataLayer || [];
		let data = {}; // variable to hold data that needs to be sent to dataLayer.
		let oracleCookie = getOracleCookieId();
		if( oracleCookie ) {
			data['User.oracleCookieID'] = oracleCookie;
			data['event'] = 'OracleCookieIdRefresh';
		}
		window.dataLayer.push( data );
	}
} )();
